import { createService } from '../../utils'
import { getBaseApi } from './baseApi'
import enhanceEndpoints from './enhanceApi'

type DischargePatientInput = {
  patientId: string
  reason: string
  description?: string
  notifyPatient?: boolean
}

type DischargePatientMutationVariables = {
  treatmentId: string
  input: DischargePatientInput
}

type DischargePatientMutationResponse = {
  dischargePatient?: {
    patientId: string
    treatmentId: string
  } | null
}

const DischargePatientDocument = `
  mutation dischargePatient($input: DischargePatientInput!) {
    dischargePatient(input: $input) {
      patientId
      treatmentId
    }
  }
`

const patientRegistrationGQLService = createService(
  ({ origin, getAccessToken }) => {
    const api = enhanceEndpoints(getBaseApi(origin, getAccessToken))

    return api.injectEndpoints({
      endpoints: (build) => ({
        dischargePatient: build.mutation<
          DischargePatientMutationResponse,
          DischargePatientMutationVariables
        >({
          query: ({ input }) => ({
            document: DischargePatientDocument,
            variables: { input },
          }),
          invalidatesTags: (res, error, { input: { patientId: id }, treatmentId }) =>
            res?.dischargePatient
              ? [
                  { id, type: 'patient' as const },
                  { id: treatmentId, type: 'patient' as const },
                ]
              : [],
        }),
      }),
    })
  },
)

export const patientRegistrationApi = patientRegistrationGQLService({
  origin: `https://${process.env.PATIENT_REGISTRATION_API_DOMAIN}`,
})

export type PatientRegistrationApiType = typeof patientRegistrationApi
